import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// feat_238 (B5) — asigna empresas a la marca de un reseller (Companies.instanceId).
// Autoritativo: lo seleccionado queda en la marca; lo deseleccionado se libera.
const AssignCompaniesModal = ({ reseller, open, onClose, onSaved }) => {
  const [allCompanies, setAllCompanies] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !reseller) return;
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.get("/superadmin/overview");
        const companies = data.companies || [];
        setAllCompanies(companies);
        // Pre-seleccionar las que ya están en la marca del reseller.
        const inScope = companies
          .filter((c) => c.instanceId === reseller.whitelabelScopeId)
          .map((c) => c.id);
        setSelected(new Set(inScope));
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, reseller]);

  const toggle = (id, checked) => {
    setSelected((prev) => {
      const s = new Set(prev);
      if (checked) s.add(id);
      else s.delete(id);
      return s;
    });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/superadmin/resellers/${reseller.id}/companies`, {
        companyIds: [...selected],
      });
      toast.success("Empresas asignadas");
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Asignar empresas a {reseller?.name}</DialogTitle>
      <DialogContent>
        <Alert severity="info" style={{ marginBottom: 12 }}>
          Las empresas seleccionadas quedarán bajo la marca{" "}
          <strong>{reseller?.whitelabelScope?.name}</strong>. Las que
          destildes se liberan (vuelven a WAIA).
        </Alert>
        {loading ? (
          <div style={{ textAlign: "center", padding: 24 }}>
            <CircularProgress size={26} />
          </div>
        ) : (
          <List dense>
            {allCompanies.map((c) => (
              <ListItem key={c.id} button onClick={() => toggle(c.id, !selected.has(c.id))}>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={selected.has(c.id)}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText
                  primary={c.name}
                  secondary={
                    c.whitelabel?.name
                      ? `Actual: ${c.whitelabel.name}`
                      : "Actual: WAIA (sin marca)"
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving || loading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignCompaniesModal;
